import { id } from "./id";
import { walletInfo } from "./walletInfo";
import { affiliateInfo } from "./affiliateInfo";
import { topupWithdrawRecords } from "./topupWithdrawRecords";
import { gameRecord } from "./gameRecord";
import { playerConfig } from "./playerConfig";
import { playerLogin } from "./playerLogin";
import { commissionInfo } from "./commissionInfo";
import { loyaltyInfo } from "./loyaltyInfo";
import {userTransactionSummaries} from "@/i18n/th/player/userTransactionSummaries";

export const player = {
  id: { ...id },
  walletInfo: { ...walletInfo },
  affiliateInfo: { ...affiliateInfo },
  topupWithdrawRecords: { ...topupWithdrawRecords },
  gameRecord: { ...gameRecord },
  playerConfig: { ...playerConfig },
  playerLogin: { ...playerLogin },
  commissionInfo: { ...commissionInfo },
  loyaltyInfo: { ...loyaltyInfo },
  userTransactionSummaries: {...userTransactionSummaries}
};
